module.exports = __webpack_public_path__ + "img/24.a5b17c7d.jpg";